import { showNotify } from "vant";
import i18n from "@/language";

const i18nGlobal = i18n.global as any;
/**
 * @description 全局代码错误捕捉
 * */
const errorHandler = (error: any) => {
	// 过滤 HTTP 请求错误
	if (error.status || error.status == 0) return false;
	const errorMap: { [key: string]: string } = {
		InternalError: i18nGlobal.t("msg.errorHandler.InternalError"),
		ReferenceError: i18nGlobal.t("msg.errorHandler.ReferenceError"),
		TypeError: i18nGlobal.t("msg.errorHandler.TypeError"),
		RangeError: i18nGlobal.t("msg.errorHandler.RangeError"),
		SyntaxError: i18nGlobal.t("msg.errorHandler.SyntaxError"),
		EvalError: i18nGlobal.t("msg.errorHandler.EvalError"),
		URIError: i18nGlobal.t("msg.errorHandler.URIError")
	};
	const errorName = errorMap[error.name] || i18nGlobal.t("msg.errorHandler.UnknownError");
	showNotify({
		message: `${errorName}:${error}`,
		type: "danger",
		duration: 3000
	});
};

export default errorHandler;
